export default __webpack_public_path__ + "static/media/udemy_2.50a351d7.jpg";